var relationshipTableDirective = function() {
  //noinspection JSUnresolvedFunction,NpmUsedModulesInstalled
  let relationship_table_url = require("admin/templates/partials/relationship-table.html");

  return function () {
    return {
      restrict: "E",
      templateUrl: function () {
        return relationship_table_url;
      }
    };
  };
};

export default angular.module("directives.relationshipTable", [])
  .directive("relationshipTable", relationshipTableDirective())
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/relationshipTable.directive.js
 **/